// extracted by mini-css-extract-plugin
export default {"button":"SelfCareButtonSwitch_button__5kST9"};